import React from 'react';
import CustomSelect from '../../../common/formElements/CustomSelect';
const PERMIT_ALL = 'PERMIT_ALL';
import { dynamicSort } from '../../../common/utils/api_utils';
import { pageCopyOptions, snippetCopyOptions } from './PageFormUtil';
import CommonPageSetting from './CommonPageSetting';

const GeneralPageSetting = ({
  project,
  handleNSChange,
  handleChange,
  name,
  nameError,
  slug,
  slugError,
  state,
  page,
  snippets,
  pageSnapshots,
  snippetSnapshots,
  plugins,
  pages,
}) => {
  const surface = process.env.REACT_APP_EXCHANGE_SURFACE;
  const pageURL = `https://${project ? project.seoName : ''}.preview.${surface}${slug}`;
  const handleNameFChange = (e) => {
    let { name, value } = e.target;
    let nameError = '';
    if (!value) {
      nameError = 'Name can not be empty';
    } else if (value.length > 100) {
      nameError = 'Name can not be more than 100 characters';
    } else if (!/^[a-zA-Z0-9/_-\s]+$/.test(value)) {
      nameError =
        'Page name can only contain alphanumeric characters, underscores(_), slash(/), spaces, hyphens(-) but should not starts with hyphen(-).';
    }

    if (value.startsWith('-') || value.startsWith(' ')) {
      value = value.slice('1');
    }
    let slug = value.replace(/\W+/g, '-').toLowerCase();
    handleNSChange({ [name]: value, nameError, slug, slugError: '' });
  };
  const handleSlugChange = (e) => {
    let { name, value } = e.target;
    value = value ? value.trim() : '';

    let slugError = '';
    if (!value) {
      slugError = 'Page URL cannot be empty';
    } else if (value.length > 100) {
      slugError = 'Page URL cannot be more than 100 characters';
    } else if (!/^[a-zA-Z0-9_\-]+$/.test(value)) {
      slugError =
        'Page URL can only contain alphanumeric characters, underscores(_), and hyphens(-) but should not starts with hyphen(-).';
    }
    value = value.replace(/^\-+/, '').replace(/\W+/g, '-').toLowerCase();
    handleNSChange({ [name]: value, slugError });
  };
  const pageLayoutOptions = () => {
    let options = [{ value: '', label: '- Select One -' }];
    if (snippets.length > 0) {
      options = options.concat(
        snippets
          .filter((snippet) => snippet.snippetType === 'PAGE_LAYOUT')
          .sort(dynamicSort('name'))
          .map((snippet) => {
            return { value: snippet.uuid, label: snippet.name };
          }),
      );
    }
    return options;
  };
  const showPageLayout = () => {
    const { pageLayout, activeTab } = state;
    return (
      <div className="form-group">
        <label htmlFor="pageLayout">Page Layout</label>
        <small>
          ( The page content will be displayed within the Page Placeholder component available in
          the selected Page layout. )
        </small>
        <CustomSelect
          name={'pageLayout'}
          isMulti={false}
          onChange={handleChange}
          options={pageLayoutOptions()}
          value={pageLayout}
        />
      </div>
    );
  };
  const getRoleOption = () => {
    let options = [
      { value: PERMIT_ALL, label: 'Public (Anyone)' },
      { value: 'AUTHENTICATED', label: ' Secured (Only LoggedIn User)' },
    ];
    const { roles } = state;
    const roleOptions =
      roles.length > 0
        ? roles.sort(dynamicSort('name')).map((role, key) => {
            return { value: role.name, label: `Users with ${role.name} Role` };
          })
        : [];
    return [...options, ...roleOptions];
  };
  const loginPluginControls = () => {
    const { access } = state;
    if (plugins) {
      let loginPlugin = plugins.find((el) => el.code === 'LOGIN');
      if (loginPlugin) {
        return (
          <div>
            <div className="form-group">
              <label htmlFor="access">Access To:</label>
              <CustomSelect
                key={'access'}
                name={'access'}
                isMulti={true}
                onChange={handleChange}
                options={getRoleOption()}
                value={access}
              />
            </div>
          </div>
        );
      }
    }
  };

  return (
    <div className="row">
      <div className="col-12">
        <div className="form-group">
          <label htmlFor="name">Page Name</label>
          <input
            type="text"
            name="name"
            className="form-control form-control-sm"
            placeholder="Landing Page"
            value={name}
            onChange={(e) => handleNameFChange(e)}
          />
          {nameError && <p className="text-error">{nameError}</p>}
        </div>
        <div className="form-group">
          <label htmlFor="slug">
            Page URL (
            <a href={pageURL} target="_blank">
              {pageURL}
            </a>
            )
          </label>
          <input
            type="text"
            name="slug"
            className="form-control form-control-sm"
            placeholder="landing-page"
            value={slug}
            onChange={(e) => handleSlugChange(e)}
          />
          {slugError && <p className="text-error">{slugError}</p>}
        </div>
        {showPageLayout()}
        <CommonPageSetting
          pages={pages}
          page={page}
          pageSnapshots={pageSnapshots}
          snippets={snippets}
          snippetSnapshots={snippetSnapshots}
          state={state}
          handleChange={handleChange}
        />
        {loginPluginControls()}
      </div>
    </div>
  );
};

export default GeneralPageSetting;
